export const getInitials = (firstName: string, lastName: string): string => {
    const firstNameLetter = firstName[0] || '';
    const lastNameLetter = lastName[0] || '';
  
    return `${firstNameLetter}${lastNameLetter}`;
  };